/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/427-deviantart': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.953 2.909V0h-2.909l-.291.294L8.378 2.91l-.431.291h-4.9v3.994h2.694l.241.291-2.934 5.606v2.909h2.909l.291-.294 1.375-2.616.431-.291h4.9V8.806H10.26l-.241-.294z"/>'
  }
})
